import { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import "../../css/ListScores.css";
import Footer from "../Navigation/Footer";
import FetchUtil from "../../utils/FetchUtil";
import AnalyticsDateFilter from "./AnalyticsDateFilter";
import DisplaySurveyScores from "./DisplaySurveyScores";
import DisplayHarvestChart from "./DisplayHarvestChart";
import DisplayProductionChart from "./DisplayProductionChart";
import DisplayProductionBarChart from "./DisplayProductionBarChart";
import DisplayShippingChart from "./DisplayShippingChart";
import Highcharts from "highcharts";
require("highcharts/modules/accessibility")(Highcharts);
import AnalyticsHeader from "./AnalyticsHeader";


const today = new Date().toISOString().split("T")[0];
const lastWeekDate = new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000).toISOString().split("T")[0];

const lowColor = '#0da30d';
const highColor = '#f19d02';
const medColor = '#FFFF00';
const noColor = '#e2e5e9';


let chartOptionsForFarmProduct = {};
let chartOptionsForHarvest = {};
let chartOptionsForQuestion = {};
let chartOptionsForProductionRepack = {};
let chartOptionsForProductionRepackSKU = {};
let chartGroup = "";
let groupNameParam = "";
let isScoreAvailable = false;
let isHarvestChartTypeAvailable = false;
let isProductionChartTypeAvailable = false;
let isProductionSKUAvailable = false;
let isShippingChartTypeAvailable = false;
let isFarmProductChartAvailable = false;
let isRepackChartTypeAvailable = false;
let isRepackSKUAvailable = false;

let userAnalyticsList = [];
function setUserAnalytics(analyticList) {
	userAnalyticsList = analyticList;
}

function ListScores() {
	const navigate = useNavigate();
	let location = useLocation();
	const [isUserAnalyticsLoaded, setIsUserAnalyticsLoaded] = useState(false);
	const [count, setCount] = useState(0);
	const [searchCount, setSearchCount] = useState(0);
	const [errorValue, setErrorValue] = useState([]);
	const [data, setData] = useState([]);
	const [search, setSearch] = useState({
		"startDate": lastWeekDate, "endDate": today,
		"groupList": [], "locationList": [],
		"productName": "", "productSku": "", "commodityName": ""
	});
	const [finishedLotScoreData, setFinishedLotScoreData] = useState([]);
	const [productScoreData, setProductScoreData] = useState([]);
	const [traceabilityScoreData, setTraceabilityScoreData] = useState([]);
	const { t } = useTranslation();
	let chartType = "";

	const { state } = location || {};
	
	const [isLoading, setIsLoading] = useState(false);
	
	if (state && state.analyticsName) {
		chartGroup = state.analyticsName;
	} else {
		chartGroup = "";
		
	}

	const noScoreText = t("page.incomplete");
	const lowText = t("page.ready") + ' (1)';
	const medText = t("page.inspect") + ' (2)';
	const highText = t("page.pause") + ' (3)';
	const yaxisLabels = [noScoreText, lowText, medText, highText];

	useEffect(() => {
		Highcharts.setOptions({
			colors: [ '#058DC7',  '#DB7093', '#b3d4ff', '#b366ff', '#F5DEB3', '#1a53ff', '#00bfa0', '#dc0ab4', 
			 '#7c1158', '#4421af', '#5d6d7e', '#FFC0CB', '#4d0000','#24CBE5',  '#e9c3ef','#80dfff',
			'#0bb4ff',  '#9b19f5', '#9e6f00',   '#2bc2c2', '#ff6696',
		    '#96a527', '#024b7a',  '#b2b0ea']
		});

		fetchUserAnalytics();
	}, []);

	useEffect(() => {
		if (chartGroup) {
			resetSearchResult();
			resetCounter();
		}

	}, [chartGroup]);

	const resetCounter = () => {
		setCount(prevCount => prevCount + 1);
	};

	function fetchUserAnalytics() {
		if (userAnalyticsList && userAnalyticsList.length > 0) {
			setIsUserAnalyticsLoaded(true);
			return;
		}
		setErrorValue([]);

		setIsUserAnalyticsLoaded(false);
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", getAll: false,
			}),
		};
		try {
			FetchUtil.fetchAPI("GetUserAnalytics", "/Service/UserService/GetUserAnalytics", requestOptions, retrieveUserAnalyticsSuccess, retrieveUserAnalyticsFail);
		} catch (error) {
			setIsUserAnalyticsLoaded(false);
			throw new Error(error.message);
		}
	}

	function retrieveUserAnalyticsFail(redirect) {
		setIsUserAnalyticsLoaded(false);
		if (redirect) {
			navigate("/");
		}
		setErrorValue([t("error.userGetAnalyticsFailed")]);
	}

	function retrieveUserAnalyticsSuccess(responseData) {
		let fetchUserAnalyticsResponse;
		if (responseData) {
			fetchUserAnalyticsResponse = responseData.fetchUserAnalyticsResponse;
			if (fetchUserAnalyticsResponse && fetchUserAnalyticsResponse.errorCode === "0") {
				setUserAnalytics(fetchUserAnalyticsResponse.analyticsList.slice())
			} else if (fetchUserAnalyticsResponse && fetchUserAnalyticsResponse.errorCode === "114") {
				navigate("/", {
					state: {
						errorMessage: t("error.sessionTimeout"),
					},
				});
			} else if (fetchUserAnalyticsResponse) {
				//setErrorValue([fetchUserAnalyticsResponse.errorMessage]);
				console.log(fetchUserAnalyticsResponse.errorMessage);
			} else {
				setErrorValue([t("error.system.fetch")]);
			}
		}

		setIsUserAnalyticsLoaded(true);
	}

	function getGroupName(chartTypeName) {
		let groupName = "";
		if (userAnalyticsList && userAnalyticsList.length > 0) {
			userAnalyticsList.map((eachAnalyticsAccess) => {
				if ((chartGroup === eachAnalyticsAccess.analyticsName) && chartTypeName === eachAnalyticsAccess.analyticsSubName) {
					groupName = eachAnalyticsAccess.surveyName;
				}
			});
		}
		return groupName;
	}

	function resetSearchResult() {
		resetSearchCounter();
		setErrorValue([]);
		isScoreAvailable = false;
		isHarvestChartTypeAvailable = false;
		isProductionChartTypeAvailable = false;
		isProductionSKUAvailable = false;
		isShippingChartTypeAvailable = false;
		isFarmProductChartAvailable = false;
		isRepackChartTypeAvailable = false;
		isRepackSKUAvailable = false;
		chartOptionsForFarmProduct = {};
		chartOptionsForHarvest = {};
		chartOptionsForQuestion = {};
		chartOptionsForProductionRepack = {};
		chartOptionsForProductionRepackSKU = {};
		groupNameParam = "";
		setData([]);
	}
	function searchSurveyScores(searchStartDate, searchEndDate, additionalFilters) {
		resetSearchResult();
		setIsLoading(true);

		let getQuestionnaireScore = true;
		let getHarvestLotScore = false;
		let getProductionScore = false;
		let getShippingScore = false;
		let getRepackScore = false

		if (additionalFilters && additionalFilters.chartType) {
			chartType = additionalFilters.chartType;
		}
		groupNameParam = getGroupName(chartType);
		if (!groupNameParam) {
			setErrorValue([t("error.analytics.nodata")]);
			return;
		}
		if (chartGroup === "Farm") {
			switch (chartType) {
				case "Annual": getQuestionnaireScore = true;
					break;
				case "Harvest": getQuestionnaireScore = true;
					break;
				case "Lot Codes":
					getHarvestLotScore = true;
					getQuestionnaireScore = false;
					isHarvestChartTypeAvailable = true;
					break;
				case "Product":
					getHarvestLotScore = false;
					getQuestionnaireScore = false;
					isFarmProductChartAvailable = true;
					break;
			}
		} else if (chartGroup === "Production") {
			switch (chartType) {
				case "Annual": getQuestionnaireScore = true;
					break;
				case "Production": getQuestionnaireScore = true;
					break;
				case "Product/SKU":
					getProductionScore = false;
					getQuestionnaireScore = false;
					isProductionSKUAvailable = true;
					break;
				case "Finished Product Lots":
					getProductionScore = true;
					getQuestionnaireScore = false;
					isProductionChartTypeAvailable = true;
					break;
			}
		} else if (chartGroup === "Repack") {
			switch (chartType) {
				case "Repack": getQuestionnaireScore = true;
					break;
				case "Product/SKU":
					getQuestionnaireScore = false;
					getRepackScore = false;
					isRepackSKUAvailable = true;
					break;
				case "Finished Product Lots":
					getRepackScore = true;
					getQuestionnaireScore = false;
					isRepackChartTypeAvailable = true;
					break;
			}
		} else if (chartGroup === "Shipping") {
			switch (chartType) {
				case "Purchase Order": getShippingScore = true;
					isShippingChartTypeAvailable = true;
					break;
			}
		} else {
			setErrorValue([t("error.analytics.nodata")]);
			return;
		}
		let lotList = [];
		if (additionalFilters.lotCode) {
			lotList.push(additionalFilters.lotCode);
		} else if (additionalFilters.finishedLotCode) {
			lotList.push(additionalFilters.finishedLotCode);
		} else if (additionalFilters.bol) {
			lotList.push(additionalFilters.bol);
		}
		const requestOptions = {
			credentials: "same-origin",
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				source: "web", status: "COM",
				startDate: searchStartDate, endDate: searchEndDate,
				groupList: (groupNameParam) ? [groupNameParam] : [],
				locationList: (additionalFilters && additionalFilters.locationList) ? additionalFilters.locationList : [],
				productName: (additionalFilters && additionalFilters.productName) ? additionalFilters.productName : "",
				productSku: (additionalFilters && additionalFilters.productSku) ? additionalFilters.productSku : "",
				commodityName: (additionalFilters && additionalFilters.commodityName) ? additionalFilters.commodityName : "",
				companyId: additionalFilters.companyId,
				lotList: lotList,
				scoreResult: (additionalFilters && additionalFilters.scoreResult) ? additionalFilters.scoreResult : "",
				getQuestionnaireScore: getQuestionnaireScore,
				getHarvestLotScore: getHarvestLotScore,
				getProductionScore: getProductionScore,
				getShippingScore: getShippingScore,
				getRepackScore: getRepackScore,
			}),
		};
		try {
			FetchUtil.fetchAPI("SearchSurveyScores", "/Service/QuestionService/GetQuestionnaireScores", requestOptions, searchSurveyScoresSuccess, searchSurveyScoresFail);
		} catch (error) {
			setIsLoading(false);
			throw new Error(error.message);
		}
	}

	function searchSurveyScoresFail(redirect) {
		setIsLoading(false);
		setErrorValue([t("error.getScoreListFailed")]);
		if (redirect) {
			navigate("/");
		}

	}

	function searchSurveyScoresSuccess(responseData) {
		let searchScoreResponse;
		if (responseData) {
			searchScoreResponse = responseData.searchScoreResponse;
			if (searchScoreResponse && searchScoreResponse.errorCode === "0") {

				if (isHarvestChartTypeAvailable) {
					setHarvestChartTypeData(searchScoreResponse.scoreList);
					isScoreAvailable = false;
				} else if (isProductionChartTypeAvailable || isRepackChartTypeAvailable) {
					setProductionChartTypeData(searchScoreResponse.scoreList);
					isScoreAvailable = false;
				} else if (isProductionSKUAvailable || isRepackSKUAvailable) {
					setProductionSKUChartTypeData(searchScoreResponse.scoreList);
					isScoreAvailable = false;
				} else if (isShippingChartTypeAvailable) {
					setShippingChartTypeData(searchScoreResponse.scoreList);
					isScoreAvailable = false;
				} else if (isFarmProductChartAvailable) {
					setFarmProductChartTypeData(searchScoreResponse.scoreList);
					isScoreAvailable = false;
				} else {
					setQuestionOptionAndData(searchScoreResponse.scoreList);
				}
				setData(searchScoreResponse.scoreList.slice());
			} else if (searchScoreResponse && searchScoreResponse.errorCode === "114") {
				setErrorValue([t("error.sessionTimeout")]);
				navigate("/");
			} else if (searchScoreResponse) {
				setErrorValue([t("error.getScoreListFailed")]);
				console.log(searchScoreResponse.errorMessage);
			}
		}
		setIsLoading(false);
	}
	function setHarvestChartTypeData(surveyObj) {
		//console.log("Set chartOptionsForHarvest : " + surveyObj.length);
		let optionValue = {};
		chartOptionsForHarvest = {};
		let xCategory = [];
		let seriesDataArr = [];
		let scoreText = "";
		let data = {};
		let series = [];
		if (surveyObj && surveyObj.length > 0) {
			surveyObj.map((survey) => {
				xCategory = [];
				series = [];
				seriesDataArr = [];
				if (survey.lotScores && survey.lotScores.length > 0) {
					survey.lotScores.map((lotScore) => {

						scoreText = (lotScore.scoreWeight === 1 ? (t("page.ready") + '(' + lotScore.scoreWeight + ')') : (lotScore.scoreWeight === 2 ? (t("page.inspect") + '(' + lotScore.scoreWeight + ')') : (lotScore.scoreWeight === 3 ? (t("page.pause") + '(' + lotScore.scoreWeight + ')') : t("page.incomplete"))));
						xCategory.push(lotScore.bol);
						data = {
							y: lotScore.scoreWeight,
							scoreText: scoreText,
							color: (lotScore.scoreResult === 'L' ? lowColor : (lotScore.scoreResult === 'H' ? highColor : (lotScore.scoreResult === 'M' ? medColor : noColor))),
							label: scoreText
						};
						seriesDataArr.push(data);


					});
				}
				let seriesData = {
					name: t("page.score"),
					showInLegend: false,
					pointWidth: 30,
					data: seriesDataArr,
				};
				series.push(seriesData);
				optionValue = {
					chart: {
						backgroundColor: '#f2ffff',
						type: 'bar',
					},
					title: {
						text: '',
						align: 'center'
					},
					credits: {
						enabled: false
					},
					exporting: {
						enabled: false
					},
					tooltip: {
						enabled: false,
						followPointer: false,
						followTouchMove: false
					},
					lang: {
						thousandsSep: ','
					},
					xAxis: {
						categories: xCategory,
						barThickness: 0.3,
						gridLineWidth: 0,
						ticks: {
							display: false
						},
						labels: {
							enabled: true
						}
					},
					yAxis: {
						title: {
							text: '',

						},
						barThickness: 12,
						maxBarThickness: 20,
						gridLineWidth: 0,
						ticks: {
							display: false
						},
						labels: {
							enabled: false
						},
						min: 0,
						max: 3,
						tickInterval: 1,
					},

					plotOptions: {
						series: {
							pointWidth: 30,
							borderRadius: '15%',
							dataLabels: {
								enabled: true,
								allowOverlap: true,
								overflow: "none",
								align: 'right',
								formatter() {
									return this.point.label
								}
							}
						},

					},
					legend: {
						enabled: false,
						layout: 'vertical',
						align: 'left',
						verticalAlign: 'middle',
						borderWidth: 0
					},
				};
				chartOptionsForHarvest[survey.answerId] = optionValue;
				//console.log("Set chartOptionsForHarvest after a option: " + chartOptionsForHarvest[survey.answerId].title.text);

				//console.log("Set chartOptionsForHarvest score: " + series.length);
				if (series.length > 0) {
					chartOptionsForHarvest[survey.answerId]['series'] = series;
				}

				//console.log("Set chartOptionsForHarvest after a score: " + Object.keys(chartOptionsForHarvest).length);
			});
		}
		//console.log("Set chartOptionsForHarvest complete: " + Object.keys(chartOptionsForHarvest).length);
		//isHarvestChartTypeAvailable = true;
	}

	function setFarmProductChartTypeData(surveyObj) {
		//console.log("Set chartOptionsForFarmProduct : " + surveyObj.length);
		let optionValue = {};
		chartOptionsForFarmProduct = {};
		let xCategory = [];
		let seriesDataArr = [];
		let data = {};
		let scoreText = "";
		let series = [];
		if (surveyObj && surveyObj.length > 0) {
			surveyObj.map((survey) => {
				xCategory = [];
				seriesDataArr = [];
				series = [];
				if (survey.productList && survey.productList.length > 0) {
					survey.productList.map((product) => {

						xCategory.push(product);
						scoreText = (survey.scoreWeight === 1 ? (t("page.ready") + '(' + survey.scoreWeight + ')') : (survey.scoreWeight === 2 ? (t("page.inspect") + '(' + survey.scoreWeight + ')') : (survey.scoreWeight === 3 ? (t("page.pause") + '(' + survey.scoreWeight + ')') : t("page.incomplete"))));
						data = {
							scoreText: scoreText,
							y: survey.scoreWeight,
							color: (survey.scoreResult === 'L' ? lowColor : (survey.scoreResult === 'H' ? highColor : (survey.scoreResult === 'M' ? medColor : noColor))),
							label: scoreText,
						};
						seriesDataArr.push(data);

					});
				}
				let seriesData = {
					name: t("page.score"),
					pointWidth: 30,
					showInLegend: false,
					data: seriesDataArr,
				};
				series.push(seriesData);
				optionValue = {
					chart: {
						backgroundColor: '#f2ffff',
						type: 'bar',
					},
					title: {
						text: '',
						align: 'center'
					},
					credits: {
						enabled: false
					},
					exporting: {
						enabled: false
					},
					tooltip: {
						enabled: false,
						followPointer: false,
						followTouchMove: false
					},
					lang: {
						thousandsSep: ','
					},
					xAxis: {
						categories: xCategory,
						barThickness: 0.3,
						gridLineWidth: 0,
						ticks: {
							display: false
						},
						labels: {
							enabled: true
						}
					},
					yAxis: {
						title: {
							text: '',

						},
						barThickness: 12,
						maxBarThickness: 20,
						gridLineWidth: 0,
						ticks: {
							display: false
						},
						labels: {
							enabled: false
						},
						min: 0,
						max: 3,
						tickInterval: 1,
					},
					plotOptions: {
						series: {
							borderRadius: '15%',
							pointWidth: 30,
							dataLabels: {
								enabled: true,
								allowOverlap: true,
								overflow: "none",
								align: 'right',
								formatter() {
									return this.point.label
								}
							}
						},

					},
					legend: {
						enabled: false,
						layout: 'vertical',
						align: 'left',
						verticalAlign: 'middle',
						borderWidth: 0
					},
				};
				chartOptionsForFarmProduct[survey.answerId] = optionValue;
				//console.log("Set chartOptionsForFarmProduct after a option: " + chartOptionsForFarmProduct[survey.answerId].title.text);
				//console.log("Set chartOptionsForFarmProduct score: " + series.length);
				if (series.length > 0) {
					chartOptionsForFarmProduct[survey.answerId]['series'] = series;
				}

				//console.log("Set chartOptionsForFarmProduct after a score: " + Object.keys(chartOptionsForFarmProduct).length);
			});
		}
		//console.log("Set chartOptionsForFarmProduct complete: " + Object.keys(chartOptionsForFarmProduct).length);
		//isHarvestChartTypeAvailable = true;
	}
	function setProductionChartTypeData(surveyObj) {
		let finishedLotScoreInfo = [];
		let finishedLotScoreRow = {};
		chartOptionsForProductionRepack = {};
		let xCategory = [];
		let seriesDataArr = [];
		let data = {};
		let series = [];
		let allProducts = [];
		let eachSeries = {};
		let flScore;
		let color = noColor;
		if (surveyObj && surveyObj.length > 0) {
			surveyObj.map((survey) => {
				finishedLotScoreRow = {};
				seriesDataArr = [];
				if (survey.finishedLotScores && survey.finishedLotScores.length > 0) {
					survey.finishedLotScores.map((finishedLotScore) => {
						if (isRepackChartTypeAvailable) {
							xCategory.push(finishedLotScore.repackDate);
						} else {
							xCategory.push(finishedLotScore.productionDate);
						}

						finishedLotScoreRow = {
							finishedLotCode: finishedLotScore.finishedLotCode,
							productionDate: finishedLotScore.productionDate,
							scoreResult: finishedLotScore.scoreResult,
							scoreWeight: finishedLotScore.scoreWeight,
							product: "",
							repackDate: finishedLotScore.repackDate,
						}
						if (survey.productList && survey.productList.length > 0) {
							survey.productList.map((productValue) => {
								if (allProducts.indexOf(productValue) === -1) {
									allProducts.push(productValue);
								}

								finishedLotScoreRow["product"] = productValue;
								finishedLotScoreInfo.push(finishedLotScoreRow);
							});
						}
					});
				}
			});
		}

		if (allProducts && allProducts.length > 0) {
			allProducts.map((eachProduct) => {
				seriesDataArr = [];
				eachSeries = {};
				//eachSeries["type"] = 'bar';
				eachSeries["name"] = eachProduct;
				eachSeries["pointWidth"] = 30;
				if (surveyObj && surveyObj.length > 0) {
					surveyObj.map((survey) => {
						data = {};
						if (survey.finishedLotScores && survey.finishedLotScores.length > 0) {
							flScore = survey.finishedLotScores[0];
							if (survey.productList.indexOf(eachProduct) !== -1) {
								if (flScore.scoreResult === 'L') {
									color = lowColor;
								} else if (flScore.scoreResult === 'H') {
									color = highColor;
								} else if (flScore.scoreResult === 'M') {
									color = medColor;
								} else {
									color = noColor;
								}

								data = {
									y: flScore.scoreWeight,
									color: color,
									dataLabels: {
										enabled: true,
										y: flScore.scoreWeight,
										align: 'center',
										color: color,
										crop: false,
										useHTML: true,
										allowOverlap: false,
										overflow: 'none',
										fontSize: '1em',
										format: flScore.scoreWeight
									}

								}
							} else {
								data = {
									y: 0

								}
							}

							seriesDataArr.push(data);
						}
					});
				}
				eachSeries["data"] = seriesDataArr;
				series.push(eachSeries);
			});


		}


		let description = "";
		if (isRepackChartTypeAvailable) {
			description = t("page.repackDate");
		} else {
			description = t("page.productionDate");
		}
		chartOptionsForProductionRepack = {
			chart: {
				type: 'column'
			},
			credits: {
				enabled: false
			},
			title: {
				text: '',
				align: 'left'
			},
			subtitle: {
				text:
					'',
				align: 'left'
			},
			xAxis: {
				categories: xCategory,
				crosshair: true,
				accessibility: {
					description: description
				}
			},
			yAxis: {
				min: 0,
				max: 3,
				tickInterval: 1,
				title: {
					text: ''
				},
				labels: {
					formatter: function() {
						return yaxisLabels[this.value];
					}
				}
			},
			tooltip: {
				valueSuffix: ' '
			},
			plotOptions: {
				column: {
					pointPadding: 0.2,
					borderWidth: 0,
				}
			},
			series: series
		};
		setFinishedLotScoreData(finishedLotScoreInfo);
		//isProductionChartTypeAvailable = true;
	}
	function setProductionSKUChartTypeData(surveyObj) {
		let productScoreInfo = [];
		let productScoreRow = {};
		chartOptionsForProductionRepackSKU = {};
		let xCategory = [];
		let seriesDataArr = [];
		let data = {};
		let series = [];
		let allProducts = [];
		let eachSeries = {};
		let color = noColor;
		if (surveyObj && surveyObj.length > 0) {
			surveyObj.map((survey) => {
				productScoreRow = {};
				seriesDataArr = [];
				if (isRepackSKUAvailable) {
					xCategory.push(survey.repackDate);
				} else {
					xCategory.push(survey.productionDate);
				}
				productScoreRow = {
					product: "",
					productionDate: survey.productionDate,
					scoreResult: survey.scoreResult,
					scoreWeight: survey.scoreWeight,
					repackDate: survey.repackDate,
				}

				if (survey.productList && survey.productList.length > 0) {
					survey.productList.map((productValue) => {
						if (allProducts.indexOf(productValue) === -1) {
							allProducts.push(productValue);
						}

						productScoreRow["product"] = productValue;
						productScoreInfo.push(productScoreRow);
					});
				}
			});
		}

		if (allProducts && allProducts.length > 0) {
			allProducts.map((eachProduct) => {
				seriesDataArr = [];
				eachSeries = {};
				//eachSeries["type"] = 'bar';
				eachSeries["name"] = eachProduct;
				eachSeries["pointWidth"] = 30;
				if (surveyObj && surveyObj.length > 0) {
					surveyObj.map((survey) => {
						data = {};
						if (survey.productList.indexOf(eachProduct) !== -1) {
							if (survey.scoreResult === 'L') {
								color = lowColor;
							} else if (survey.scoreResult === 'H') {
								color = highColor;
							} else if (survey.scoreResult === 'M') {
								color = medColor;
							} else {
								color = noColor;
							}
							data = {
								y: survey.scoreWeight,
								//color: color,
								dataLabels: {
									enabled: true,
									y: survey.scoreWeight,
									align: 'center',
									//color: color,
									crop: false,
									useHTML: true,
									allowOverlap: false,
									overflow: 'none',
									fontSize: '1em',
									format: survey.scoreWeight
								}

							}
						} else {
							data = {
								y: 0

							}
						}

						seriesDataArr.push(data);
					});
				}
				eachSeries["data"] = seriesDataArr;
				series.push(eachSeries);
			});


		}
		let description = "";
		if (isRepackSKUAvailable) {
			description = t("page.repackDate");
		} else {
			description = t("page.productionDate");
		}
		chartOptionsForProductionRepackSKU = {
			chart: {
				type: 'column'
			},
			credits: {
				enabled: false
			},
			title: {
				text: '',
				align: 'left'
			},
			subtitle: {
				text:
					'',
				align: 'left'
			},
			xAxis: {
				categories: xCategory,
				crosshair: true,
				accessibility: {
					description: description
				}
			},
			yAxis: {
				min: 0,
				max: 3,
				tickInterval: 1,
				title: {
					text: ''
				},
				labels: {
					formatter: function() {
						return yaxisLabels[this.value];
					}
				}
			},
			tooltip: {
				valueSuffix: ' '
			},
			plotOptions: {
				column: {
					pointPadding: 0.2,
					borderWidth: 0,
				}
			},
			series: series
		}
		setProductScoreData(productScoreInfo);
		//isProductionChartTypeAvailable = true;
	}
	function setShippingChartTypeData(surveyObj) {
		let traceabilityScoreInfo = [];
		let traceabilityScoreRow = {};
		if (surveyObj && surveyObj.length > 0) {
			surveyObj.map((survey) => {
				traceabilityScoreRow = {};
				if (survey.traceabilityScores && survey.traceabilityScores.length > 0) {
					survey.traceabilityScores.map((traceabilityScore) => {
						traceabilityScoreRow = {
							traceability: traceabilityScore.traceability,
							shippingDate: traceabilityScore.shippingDate,
							scoreResult: traceabilityScore.scoreResult,
							scoreWeight: traceabilityScore.scoreWeight,
							product: "",
						}
						traceabilityScoreInfo.push(traceabilityScoreRow);
					});
				}
			});
		}
		setTraceabilityScoreData(traceabilityScoreInfo);
		//isShippingChartTypeAvailable = true;
	}
	function setQuestionOptionAndData(surveyObj) {
		//console.log("Set chartOptionsForQuestion : " + surveyObj.length);
		let optionValue = {};
		chartOptionsForQuestion = {};
		if (surveyObj && surveyObj.length > 0) {

			surveyObj.map((survey) => {
				optionValue = {
					chart: {
						backgroundColor: '#f2ffff',
						type: 'bar',
					},
					title: {
						text: '',
						align: 'center'
					},
					credits: {
						enabled: false
					},
					exporting: {
						enabled: false
					},
					tooltip: {
						enabled: false,
						followPointer: false,
						followTouchMove: false
					},
					lang: {
						thousandsSep: ','
					},
					xAxis: {
						categories: [survey.startDate + (survey.endDate ? ' - ' + survey.endDate : '')],
						barThickness: 0.3,
						gridLineWidth: 0,
						ticks: {
							display: false
						},
						labels: {
							enabled: true
						}
					},
					yAxis: {
						title: {
							text: '',

						},
						barThickness: 12,
						maxBarThickness: 20,
						gridLineWidth: 0,
						ticks: {
							display: false
						},
						labels: {
							enabled: false,
							align: 'center',
							allowOverlap: true,
							formatter: function() {
								return this.name;
							}
						}
					},

					plotOptions: {
						series: {
							pointWidth: 25,
							borderRadius: '15%',
							stacking: 'normal',
							dataLabels: {
								enabled: true,
								allowOverlap: true,
								overflow: "none",
							}
						}
					},
					legend: {
						enabled: false,
						layout: 'vertical',
						align: 'left',
						verticalAlign: 'middle',
						borderWidth: 0
					},
				};
				chartOptionsForQuestion[survey.answerId] = optionValue;
				//console.log("Set chartOptionsForQuestion after a option: " + chartOptionsForQuestion[survey.answerId].title.text);
				let series = [];
				survey.sectionScores.map((scores) => {
					let seriesData = {
						showInLegend: false,
						type: 'bar',
						name: scores.sectionDescription,
						data: [{
							y: 100,
							color: (scores.scoreResult === 'L' ? lowColor : (scores.scoreResult === 'H' ? highColor : (scores.scoreResult === 'M' ? medColor : noColor))),
							dataLabels: {
								enabled: true,
								y: 20,
								align: 'center',
								color: '#000000',
								crop: false,
								useHTML: true,
								allowOverlap: true,
								overflow: 'none',
								fontSize: '1em',
								format: scores.sectionDescription
							}
						}],
					};
					series.push(seriesData);
				})
				//console.log("Set chartOptionsForQuestion score: " + series.length);
				if (series.length > 0) {
					chartOptionsForQuestion[survey.answerId]['series'] = series;
				}

				//console.log("Set chartOptionsForQuestion after a score: " + Object.keys(chartOptionsForQuestion).length);
			});
		}
		//console.log("Set chartOptionsForQuestion complete: " + Object.keys(chartOptionsForQuestion).length);
		isScoreAvailable = true;
	}

	const onClickFilterCallback = (searchStartDate, searchEndDate, additionalFilters) => {
		if (!searchStartDate || !searchEndDate || !additionalFilters || !additionalFilters.chartType) {
			setErrorValue([t("error.analytics.nodata")]);
			return;
		}

		searchSurveyScores(searchStartDate, searchEndDate, additionalFilters);
	}

	const resetSearchCounter = () => {
		setSearchCount(prevCount => prevCount + 1);
	};

	const onSearchDateValChange = (searchStartDate, searchEndDate) => {
		if (searchStartDate === search.startDate && searchEndDate === search.endDate) {
			//console.log('No change in search')
			//return
		}
		search.startDate = searchStartDate;
		search.endDate = searchEndDate;
		//console.log('search change:'+ search.startDate + ' : '+ search.endDate);
		//searchSurveyScores(searchStartDate, searchEndDate);
	}

	return (
		<div className="container-fluid">
			<AnalyticsHeader />
			<div className={"container-fluid container_list viewh-85 qbg"}>
				<div className="row">
					<div className="col">
						<div
							id="inerrorMessage"
							className={
								(errorValue && errorValue.length > 0) ? "errorblock" : "errorblock hide"
							}
						>
							{(errorValue && errorValue.length > 0) ?
								(
									errorValue.map((errorData) => (
										<p className="message-line">{errorData}</p>
									))
								) : ""}
						</div>
					</div>
				</div>

				<div className="row">
					<div className="col">
						<div id="placeholder_1" className="placeholder-pg"></div>
					</div>
				</div>
				{(chartGroup && isUserAnalyticsLoaded) ? (
					<>
					<div className="row">
						<h2>{chartGroup}</h2>
					</div>
					<div className="row">
						<div className="col" style={{ maxWidth: "20vw", borderRight: "solid" }}>
							<AnalyticsDateFilter key={count} onClickFilterCallback={onClickFilterCallback} searchVal={search}
								onSearchValChange={onSearchDateValChange} selectedChartGroup={chartGroup} userAnalyticsList={userAnalyticsList}
							/>
							{(isLoading) && (<div> <span class="spinner-border spinner-border-sm spinner-lg-size"></span> </div>)}
						</div>
						<div key={searchCount} className="col" style={{ minWidth: "75vw" }}>
							{(isScoreAvailable) ? (
								(data && data.length > 0) ? (
									data.map((survey, surveyIndex) => (
										(survey) && (
											<DisplaySurveyScores key={searchCount} survey={survey} surveyIndex={surveyIndex} chartOptions={chartOptionsForQuestion} groupName={groupNameParam}/>
										)
									))
								) : (<> {t("error.analytics.nodata")}</>))
								: (<></>)}
							{(isHarvestChartTypeAvailable) ? (
								(data && data.length > 0) ? (
									data.map((survey, surveyIndex) => (
										(survey && survey.lotScores && survey.lotScores.length > 0) && (
											<DisplayHarvestChart key={searchCount} heading={t("page.harvest.bol")} survey={survey} surveyIndex={surveyIndex} chartOptions={chartOptionsForHarvest} />
										)
									))
								) : (<> {t("error.analytics.nodata")}</>))
								: (<></>)}
							{(isFarmProductChartAvailable) ? (
								(data && data.length > 0) ? (
									data.map((survey, surveyIndex) => (
										(survey && survey.productList && survey.productList.length > 0) && (
											<DisplayHarvestChart key={searchCount} heading={t("page.farm.product")} survey={survey} surveyIndex={surveyIndex} chartOptions={chartOptionsForFarmProduct} />
										)
									))
								) : (<> {t("error.analytics.nodata")}</>))
								: (<></>)}
							{(isProductionChartTypeAvailable || isRepackChartTypeAvailable) ? (
								(finishedLotScoreData && finishedLotScoreData.length > 0) ? (
									<>
										<DisplayProductionChart key={searchCount} finishedLotScoreData={finishedLotScoreData} isRepackChartTypeAvailable={isRepackChartTypeAvailable} />
									</>
								) : (<> {t("error.analytics.nodata")}</>))
								: (<></>)}
							{(isProductionSKUAvailable || isRepackSKUAvailable) ? (
								(productScoreData && productScoreData.length > 0) ? (
									<>
										<DisplayProductionBarChart key={searchCount} chartOptions={chartOptionsForProductionRepackSKU} />
									</>
								) : (<> {t("error.analytics.nodata")}</>))
								: (<></>)}
							{(isShippingChartTypeAvailable) ? (
								(traceabilityScoreData && traceabilityScoreData.length > 0) ? (
									<>
										<DisplayShippingChart key={searchCount} traceabilityScoreData={traceabilityScoreData} />
									</>
								) : (<> {t("error.analytics.nodata")}</>))
								: (<></>)}
						</div>
					</div>
					</>
				) : (<> {t("page.analytics.info")}</>)}
				<div className="row">
					<div className="col">
						<div id="placeholder_2" className="placeholder-pg"></div>
					</div>
				</div>

				<div className="row">
					<div className="col">
						<div
							id="berrorMessage"
							className={
								(errorValue && errorValue.length > 0) ? "errorblock" : "errorblock hide"
							}
						>
							{(errorValue && errorValue.length > 0) ? (
								errorValue.map((errorData) => (
									<p className="message-line">{errorData}</p>
								))
							) : ""}
						</div>
					</div>
				</div>
			</div>
			<div className="footer_container">
				<Footer />
			</div>
		</div>
	);
}

export default ListScores;